export const CURATED_COLLECTIONS_PAGE = 'curatedcollections';
export const IS_LIST_VIEW_KEY = 'curated_collections_is_list_view';
